import SkipLink from '@stories/Components/Misc/SkipLink/SkipLink';
import * as React from 'react';
import S from './EmbeddedForm.styles';
const EmbeddedForm = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(S.WrapperStyles, null),
        React.createElement(SkipLink, { type: "inline", translations: props.translations }),
        React.createElement(S.Container, null,
            props.subtitle && React.createElement(S.Subtitle, null, props.subtitle),
            React.createElement(S.Title, null, props.title),
            props.introduction && React.createElement(S.Introduction, null, props.introduction))));
};
export default EmbeddedForm;
